<template>
  <div class="donut-chart-container">
    <div class="filters">
      <select
        v-model="selectedPortal"
        class="filter-select"
      >
        <option value="">
          Selecione um Portal
        </option>
        <option
          v-for="portal in uniquePortals"
          :key="portal"
          :value="portal"
        >
          {{ portal }}
        </option>
      </select>

      <input
        v-model="startDate"
        type="date"
        class="filter-select"
        placeholder="Data Inicial"
      >
      <input
        v-model="endDate"
        type="date"
        min="startDate"
        class="filter-select"
        placeholder="Data Final"
      >
    </div>

    <div class="chart-box">
      <doughnut-chart-base
        :key="selectedPortal + startDate + endDate"
        :chart-data="chartData"
        :options="chartOptions"
      />
    </div>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs'
import { reactiveProp } from 'vue-chartjs/es/mixins'
import fetchPortalBiddingData from '@/syslic/dashboard/portal/portalBiddingService'
import filterPortalBiddingData from '@/syslic/dashboard/portal/portalBiddingFilter'

const DoughnutChartBase = {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData(newData) {
      this.renderChart(newData, this.options)
    },
  },
}

export default {
  name: 'DoughnutChart',
  components: {
    DoughnutChartBase,
  },
  data() {
    return {
      selectedPortal: '',
      startDate: '',
      endDate: '',
      rawData: [],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'top',
          },
          title: {
            display: true,
            text: 'Desempenho por Portal',
          },
          tooltip: {
            callbacks: {
              label: context => {
                const idx = context.dataIndex
                const rawValues = context.chart.data.rawValues || {}

                if (idx === 0) return `Número de Licitações: ${rawValues.totalBiddings ?? 0}`
                if (idx === 1) return `Taxa de Conversão: ${rawValues.conversionRate ?? 0}%`
                if (idx === 2) return `Valor Médio: R$ ${rawValues.averageContractValue ?? 0}`
                if (idx === 3) return `Valor Total: R$ ${rawValues.totalContractValue ?? 0}`
                return context.dataset.data[idx]
              },
            },
          },
        },
      },
    }
  },
  computed: {
    chartData() {
      if (!this.selectedPortal) {
        return {
          labels: ['Número de Licitações', 'Taxa de Conversão (%)', 'Valor Médio dos Contratos (R$)'],
          datasets: [{
            label: 'Sem dados',
            data: [0, 0, 0],
            backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
          }],
          rawValues: {
            totalBiddings: 0,
            conversionRate: 0,
            averageContractValue: 0,
          },
        }
      }

      return filterPortalBiddingData(this.rawData, {
        portal: this.selectedPortal,
        startDate: this.startDate || null,
        endDate: this.endDate || null,
      })
    },
    uniquePortals() {
      const set = new Set()
      this.rawData.forEach(item => {
        if (item.platform) set.add(item.platform)
      })
      return Array.from(set).sort()
    },
  },
  async mounted() {
    const data = await fetchPortalBiddingData(this)
    this.rawData = Array.isArray(data) ? data : []
    const [firstPortal] = this.uniquePortals
    if (firstPortal) {
      this.selectedPortal = firstPortal
    }
  },
}
</script>

<style scoped>
.donut-chart-container {
  width: 100%;
}

.filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}

.filter-select {
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
  max-width: 250px; /* limite de largura */
  width: 100%;
}

.chart-box {
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chart-box {
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 320px) {
  .chart-box {
    height: 400px;
    transform: scale(0.8);
  }
}

@media (max-width: 375px) {
  .chart-box {
    height: 400px;
    transform: scale(0.8);
  }
}
</style>
